module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9nP8v"))).then(() => parcelRequire('1iHdE'));